import styled from "styled-components";

export const CrewStyle = styled.div`
    height: 100vh;
    width: 100%;
    background-color: #E5F8FA;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

export const WrapContent = styled.div`
    width: 75%;
    height: 80%;
    display: flex;
    flex-direction: column;
    /* background-color: red; */

    h1{
        margin: -10px 9px;
        padding: 0;
        color: #FF5742;
    }

    h2{
        color: black;
        font-size: 15px;
        margin-top: auto;
    }

    h3{
        color: #005CA9;
        font-size: 30px;
        margin: 20px 9px;
        padding-top: 30px;
    }
`

export const SesiImage = styled.img`
    width: 200px;
    height: 90px;
    margin: 0;
`

export const LoginCrewCard = styled.div`
    border-radius: 20px;
    background-color: #E0E0E0CC;
    height: 200px;
    width: 600px;
    margin-top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.5);
    z-index: 999;
`

export const WrapContentLoginCrewCard = styled.div`
    display: flex;
    flex-direction: column;
    width: 95%;
    height: 85%;
    position: relative;
    /* background-color: red; */

    h1{
        color: black;
        font-size: 25px;
        margin-bottom: 10px;
    }

    a{
        color: #FF5641;
        font-size: 15px;
        font-weight: 700;
        align-self: flex-end;
        margin-right: 5px;
        cursor: pointer;
    }

    h2{
        color: black;
        font-size: 15px;
        margin-left: 10px;
        margin-top: auto;
        margin-bottom: 0;
    }

    p{
        color: #005CA9;
        font-size: 18px;
        font-weight: 400;
        margin-left: 10px;
        margin-top: 0;
        cursor: pointer;
    }
`

export const LoginField = styled.input`
    width: 98%;
    height: 40px;
    background-color: #F2F2F2;
    border: none;
    color: black;
    font-size: 18px;
    font-weight: 500;
    border-end-end-radius: 20px;
    border-end-start-radius: 20px;
    border-start-end-radius: 20px;
    border-start-start-radius: 20px;
    padding-left: 10px;
    margin-bottom: 15px;
    transition: all 0.3s ease;

    &:focus {
        border: 1px solid #5c8e;
        box-shadow: 0 0 8px rgba(92, 142, 200, 0.5); 
        outline: none; 
    }
`

export const StaticImage = styled.img`
    position: absolute;
    height: 100%; 
    top: -20px;
    pointer-events: none;
    right: 0;
    z-index: 0;
`

export const EnterButton = styled.button`
    background-color: #FF5641;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    padding: 8px;
    border: none;
    border-radius: 50px / 40px;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    position: absolute;
    bottom: -30px; 
    right: 10px; 
`